import {
     trigger,
     state,
     style,
     transition,
     animate,
   } from "@angular/animations";
   
   export const rotate = trigger("rotate", [
     state(
       "default",
       style({
         transform: "rotate(0)",
       })
     ),
     state(
       "rotated",
       style({
         transform: "rotate(180deg)",
       })
     ),
     transition("default <=> rotated", animate("300ms ease-in-out")),
   ]);
   